
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import men_teacher from "../assets/img/thumbnail-icon.png"
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import { checkRole } from "../model";
import { useFormik } from "formik";
import AlertErrorForm from "../component/AlertErrorForm";
import { confirmAlert } from "react-confirm-alert";
import getCroppedImg from "../component/getCroppedImg";
import Cropper from "react-easy-crop";
import Spinner from "../component/Spinner";

export default function DanhSachKhoaHoc() {
    const { user } = useSelector((state) => state.auth);
    const [modalFormShow, setModalFormShow] = useState(false)
    const [listData, setListData] = useState([])

    const inputRef = useRef(null);
    const allowAdd = checkRole(user, "khoa-hoc", 'add');
    const allowEdit = checkRole(user, "khoa-hoc", 'edit');

    const [loading, setLoading] = useState(false);

    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [nameFile, setNameFile] = useState(null);
    const [avatar, setAvatar] = useState(null);
    const [loadingImage, setLoadingImage] = useState(false)
    const [detail, setDetail] = useState(null)

    useEffect(
        function () {
            let mounted = true;
            setLoading(true)
            Axios.get(URL_LIST_ALL + "learninghub_khoahoc?limit=50&orderby=position-asc&status=1", user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListData(res.data.data);
                        }
                    } else console.log(res.data.message);
                    setLoading(false)
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);

        }, [user]
    );

    const formik = useFormik({
        initialValues: detail ? detail : { title: '', thumbnail: null, description: '', status: 1 },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tiêu đề'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
                if (avatar) {
                    values.thumbnail = avatar
                }
                if (detail) {
                    setLoading(true)
                    // console.log(values);
                    Axios.put(URL_LIST_ALL + 'learninghub_khoahoc/' + detail.id, values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                } else {
                    setLoading(true)
                    // console.log(values);
                    Axios.post(URL_LIST_ALL + 'learninghub_khoahoc', values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }


            }, 200);
            setSubmitting(false)
        },
    });

    // Hàm này lưu vùng crop tính theo pixel
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // Khi người dùng chọn file từ input
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageDataUrl = await readFile(file);
            setNameFile(file.name);
            setImageSrc(imageDataUrl);
            setShowCropper(true);
        }
    };

    // Hàm đọc file thành base64 để hiển thị cropper
    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.readAsDataURL(file);
        });
    }

    // Hàm crop và upload ảnh
    const onCropConfirm = async () => {
        try {
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
            const resizedBlob = croppedImageBlob; // hoặc resize tiếp nếu muốn

            let data = new FormData();
            data.append("type", "s3");
            data.append("name", "file");
            data.append("file", resizedBlob, nameFile); // đổi tên nếu muốn
            data.append("filetype", resizedBlob.type);

            setLoadingImage(true);
            Axios.post(URL_LIST_ALL + "fileupload", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: user.config.headers.Authorization,
                },
            })
                .then((res) => {
                    if (res.data.status === "success") {
                        const url = res.data.message;
                        if (url) {
                            setAvatar(url);
                            setLoadingImage(false);
                            setShowCropper(false);
                            setImageSrc(null);
                        }
                    } else {
                        setLoadingImage(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingImage(false);
                });
        } catch (e) {
            console.error(e);
        }
    };

    const onDelete = (id) => {
        confirmAlert({
            title: 'Cảnh báo',
            message: "Bạn có muốn xóa khóa học này ?",
            buttons: [{
                label: 'Đồng ý', onClick: () => {
                    setLoading(true)
                    Axios.put(URL_LIST_ALL + 'learninghub_khoahoc/' + id, { status: 0 }, user.config).then(res => {
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }
            },
            { label: 'Hủy' }
            ]
        });

    }

    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Các khóa học đang diễn ra
                </li>
            </ul>
        </div>

        <div className="w-100 list-profile">
            <div className="row">
                <h3 className="col-12 mb-3">Danh Sách Các Khóa Học</h3>
                <div className="row">
                    {loading ? <div className="w-100 text-center"><Spinner /></div> : ''}
                    {listData && listData.map((item) => {
                        return (<div className="col-12 col-sm-3 profile-item" key={item.id}>
                            <div className="wrapper border shadow">
                                <div className="w-100 d-flex justify-content-center p-3" onClick={() => {
                                    window.location.href = "/khoa-hoc-chi-tiet/" + item.id
                                }}>
                                    <div className="avatar-group">
                                        <img src={item.thumbnail ? item.thumbnail : men_teacher} alt="" className="" />
                                    </div>
                                </div>
                                <div className="w-100 p-3 pt-0" onClick={() => {
                                    window.location.href = "/khoa-hoc-chi-tiet/" + item.id
                                }}>
                                    <h5 className="w-100 text-center title">{item.title}</h5>
                                    <p className="w-100 text-center description mt-2">
                                        {item.description}
                                    </p>
                                </div>
                                {allowEdit &&
                                    <div className="row group-action">
                                        <div className="col-6 pr-0">
                                            <button type="button" className="w-100  btn btn-warning" onClick={() => {
                                                setDetail(item)
                                                if (item.thumbnail) {
                                                    setAvatar(item.thumbnail)
                                                }
                                                setModalFormShow(true)
                                            }}>
                                                <i className="fas fa-pencil-alt"></i> Sửa
                                            </button>
                                        </div>
                                        <div className="col-6 pl-0">
                                            <button type="button" className="w-100 btn btn-danger" onClick={() => onDelete(item.id)}><i className="fas fa-trash"></i> Xóa</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>)
                    })}
                    {allowAdd && <div className="col-12 mt-3 profile-item">
                        <button className="btn btn-success" type="button" onClick={() => setModalFormShow(true)}>Thêm mới</button>
                    </div>}
                </div>
            </div>
        </div>
        <Modal show={modalFormShow} onHide={() => {
            setModalFormShow(false)
            setDetail(null)
            setAvatar(null)
        }} animation={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Thêm mới khóa học</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="w-100 modal-profile">
                    <form className="new-added-form  form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6  form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Khóa học tân tuyển" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                             <div className="col-12 col-sm-6 form-group">
                                <label>Vị trí</label>
                                <input type="number" placeholder="Nhập vị trí" className="form-control" {...formik.getFieldProps("position")} autoComplete="off"/>
                            </div>
                            <div className="col-12 col-sm-6 info-table table-responsive">
                                <h5>Ảnh đại diện:</h5>
                                <div className="avatar-group mt-3">
                                    <button type="button" className="btn p-0 btn-avatar" onClick={() => inputRef.current.click()}>
                                        {loadingImage ? (
                                            "Đang tải..."
                                        ) : avatar ? (
                                            <img src={avatar} alt="" className="avatar" />
                                        ) : (
                                            <img
                                                src={(men_teacher)}
                                                alt=""
                                                className="avatar"
                                            />
                                        )}
                                        <span className="fas fa-upload upload-icon"></span>
                                    </button>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={inputRef}
                                        style={{ display: "none" }}
                                        accept="image/*"
                                        onChange={onFileChange}
                                    />

                                    {showCropper && (
                                        <>
                                            <div className="cropper-modal">
                                                <Cropper
                                                    image={imageSrc}
                                                    crop={crop}
                                                    zoom={zoom}
                                                    aspect={1}
                                                    onCropChange={setCrop}
                                                    onZoomChange={setZoom}
                                                    onCropComplete={onCropComplete}
                                                />

                                            </div>

                                        </>
                                    )}
                                </div>
                                {showCropper && <div className="w-100 mt-2">
                                    <button type="button" className="btn btn-sm btn-info" onClick={onCropConfirm}>Lưu</button>
                                    <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => {
                                        setShowCropper(false);
                                        setImageSrc(null);
                                    }}
                                    >
                                        Hủy
                                    </button>
                                </div>}
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Mô tả <span className="text-danger">*</span></label>
                                <textarea type="text" placeholder="Nhập mô tả" className="form-control" {...formik.getFieldProps("description")} autoComplete="off"></textarea>
                            </div>
                           
                            <div className="col-12 form-group mt-5">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    </AkkhorLayout>);
}
